import { Heading, P, Section, Wrapper } from 'components/base';
import isEmpty from 'lodash-es/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';

const HeadingAndDesc = ({ data: { heading, desc }, center, headingMargin, padding, theme, id, waveTop, wrapper }) => {
  const emptyDesc = isEmpty(desc);
  const HeadingMargin = emptyDesc ? headingMargin : 'Xs';

  return (
    <Section padding={padding} theme={theme} id={id} waveTop={waveTop} >
      <Wrapper size={wrapper}>
        <Heading Tag="h2" size="L" center={center} marginBottom={HeadingMargin} bold>
          {heading}
        </Heading>
        {!emptyDesc && <P Tag="h3" marginBottom="M" center={center} size="L">{desc}</P>}
      </Wrapper>
    </Section>
  );
};

HeadingAndDesc.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    desc: PropTypes.string,
  }),
  padding: PropTypes.string,
  theme: PropTypes.string,
  waveTop: PropTypes.bool,
  id: PropTypes.string,
  center: PropTypes.bool,
  headingMargin: PropTypes.string,
  wrapper: PropTypes.string,
};
HeadingAndDesc.defaultProps = {
  padding: 'TopL',
  theme: null,
  waveTop: false,
  center: true,
  headingMargin: 'M',
  wrapper: 'MS'
}

export default HeadingAndDesc;
